import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Advertisement() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            新聞広告のご案内
          </Typography>
          　デーリー東北は、戦後間もない１９４５(昭和２０)年に創刊しました。本社のある八戸市を中心に、青森県をタテ半分に割った太平洋側と岩手県北をカバーしています。地方紙でありながらエリアが２県にまたがる全国でも珍しい新聞社です。２０２１(令和３)年現在、約９万２千部を発行し、特に八戸市内では、新聞を購読している世帯の８０％以上にご愛読いただいています。<br/>
          　地域に密着した広告、特集号はもちろん、スポーツ月刊誌「Ｄａｓｈ」、女性をメインターゲットにした生活情報誌「chou･chou（シュシュ）」などの別刷り冊子も充実。企業、団体様のメッセージやビジョンを適格に伝える記事体広告の制作も積極的に行っています。幅広いジャンルの企画、多彩な媒体を持つデーリー東北だからこそ、スポンサー様のご要望にしっかりと応えることができます。<br/>
        </Box>

        <Box my={8}>
          <Paper>
            <Typography className="font-weight-bold p-2 text-center bg-dark text-white" variant="h5" component="h2">
              新聞広告のサイズ
            </Typography>
            <Box p={3} textAlign="center">
              <Grid spacing={0} container direction="row" justify="left">
                <Grid item xs={12} className="p-2">
                  <img src="/images/ad/ad_size01.jpg" className="img-fluid" />
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Box>

        <Box my={8}>
          <Paper>
            <Typography className="font-weight-bold p-2 text-center bg-dark text-white" variant="h5" component="h2">
              新聞広告の種類
            </Typography>
            <Box p={3} textAlign="center">
              <Grid spacing={0} container direction="row" justify="left">
                <Grid item xs={12} className="p-2">
                  <img src="/images/ad/ad_type01.jpg" className="img-fluid" />
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Box>

        <Box my={8}>
          <Paper>
            <Typography className="font-weight-bold p-2 text-center bg-dark text-white" variant="h5" component="h2">
              広告の掲載位置
            </Typography>
            <Box p={3} textAlign="center">
              <Grid spacing={0} container direction="row" justify="left">
                <Grid item xs={12} className="p-2">
                  <img src="/images/ad/ad_zappou01.jpg" className="img-fluid" />
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Box>

        <Box my={8}>
          <Paper>
            <Typography className="font-weight-bold p-2 text-center bg-dark text-white" variant="h5" component="h2">
              新聞広告料金
            </Typography>
            <Box p={3} textAlign="center">
              <Grid spacing={0} container direction="row" justify="left">
                <Grid item xs={12} className="p-2">
                  <img src="/images/ad/ad_price01.jpg" className="img-fluid" /><br/>
                  <img src="/images/ad/ad_price02.jpg" className="img-fluid" /><br/>
                  <img src="/images/ad/ad_price03.jpg" className="img-fluid" /><br/>
                  <img src="/images/ad/ad_price04.jpg" className="img-fluid" /><br/>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Box>

        <Box my={8}>
          <Paper>
            <Typography className="font-weight-bold p-2 text-center bg-dark text-white" variant="h5" component="h2">
              新聞広告掲載例
            </Typography>
            <Box my={4} p={3}>
              <dl>
                <dt>北奥羽圏内スポット集中型、抜群の媒体力を発揮！</dt>
                <dd>
                  　割安な料金でお客様の用途に合わせ、サイズ・掲載面など選べる月極め広告は１カ月から１年間の単位でお申し込みいただけます。小さなスペースですが決められた回数が定期的に継続して掲載されますので、確実にしっかり浸透し確かな広告効果が得られます。
                </dd>
                <dt>使いやすさが魅力。月極広告</dt>
                <dd>
                  　題字下からテレビ面まで月極め広告はバリエーション豊か。お客様の業種・広告内容・予算に合わせてスペース・掲載面をお選びいただけます。営業案内、商品紹介、セールの案内など広告内容はバラエティーに富み使いやすさが魅力です。
                </dd>
              </dl>
              <Box textAlign="center">
                <Grid spacing={0} container direction="row" justify="left" className="text-center">
                  <Grid item xs={12} className="p-2">
                    <img src="/images/ad/ad-zappou_ex.jpg" className="img-fluid" />
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box my={4} p={3}>
              <dl>
                <dt>人材募集から突然の出来事まで対応</dt>
                <dd>
                  　優秀な人材を欲しい、急にパートが必要。突然の訃報、出火お詫び、近火見舞いなど突然の出来事から会合の告知まで臨時広告はリアルタイムで対応。葬儀広告の掲載率は高く、地元密着型の紙面は生活情報の伝達媒体として欠かせない存在です。
                </dd>
              </dl>
              <Box textAlign="center">
                <Grid spacing={0} container direction="row" justify="left" className="text-center">
                  <Grid item xs={12} className="p-2">
                    <img src="/images/ad/ad-jinji_ad_ex.jpg" className="img-fluid" />
                  </Grid>
                  <Grid item xs={12} className="p-2">
                    <img src="/images/ad/ad-sougi_ex.jpg" className="img-fluid" />
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box my={4} p={3}>
              <dl>
                <dt>読者への確かな伝達手段…営業広告</dt>
                <dd>
                  　新聞広告は企業と読者（消費者）を結ぶ架け橋。デーリー東北は「ふだんの暮らしに役立っている新聞」と高い信頼を得ています。このためデーリー東北では出稿段数による割引料金制を採用。企業の販促活動をお手伝いしています。
                </dd>
              </dl>
              <Box textAlign="center">
                <Grid spacing={0} container direction="row" justify="left" className="text-center">
                  <Grid item xs={12} className="p-2">
                    <img src="/images/ad/ad-eigyo_ex.jpg" className="img-fluid" />
                  </Grid>
                </Grid>
              </Box>
            </Box>

          </Paper>
        </Box>

        <Box my={8} id="ad-digital">
          <Paper>
            <Typography className="font-weight-bold p-2 text-center bg-dark text-white" variant="h5" component="h2">
              デーリー東北デジタル・アプリ広告
            </Typography>
            <Box p={3} textAlign="center">
              <Grid spacing={0} container direction="row" justify="left">
                <Grid item xs={12} className="p-2">
                  <img src="/images/ad/ad_digital01.jpg" className="img-fluid" />
                  <img src="/images/ad/ad_digital02.jpg" className="img-fluid" />
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北広告倫理綱領
          </Typography>
          　デーリー東北の紙上に掲載する広告は、「デーリー東北広告倫理綱領」の精神にのっとり、北奥羽全域をカバーする唯一の日刊紙としての誇りと認識をもち、その社会的使命を自覚し、つねに倫理的向上と健全な発達に努め、もって地域住民の信頼に応えるものでなければならない。
          <ul>
            <li>デーリー東北の広告は、真実を伝え、責任を負えるものでなければならない。</li>
            <li>デーリー東北の広告は、違法な内容や虚偽誇大な表現があることによって読者に不利益を与えるものであってはならない。</li>
            <li>デーリー東北の広告は、社会道義や社会秩序をみだし、良風美俗を害するものであってはならない。</li>
            <li>デーリー東北の広告は、他を中傷し、名誉を傷つけ紙面の品位をそこない、かつ報道の自由をおかすものであってはならない。</li>
            <li>デーリー東北の広告は、他の模倣を戒め、独自のものでなければならない。</li>
          </ul>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北広告掲載基準
          </Typography>
          　デーリー東北新聞社は、社会正義にのっとり、デーリー東北に掲載する広告の信頼と格調を高める目的をもって広告掲載基準を制定した。<br/>
          　その基準は、日本新聞協会広告倫理綱領並びに広告関係諸法規を勘案し、北奥羽地域に密着した唯一の日刊紙としての責任と誇りをもつものである。従って妥当でないと認めたものは一部原稿を変更するか、掲載を拒否する。<br/>
          <Box p={3} textAlign="center">
            <Grid spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={6}>
                <CustomButton href="/pdf/ad/2021sokoguide.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  2021年広告デジタルデータ入稿ガイド
                </CustomButton>
              </Grid>
            </Grid>
            <Grid spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={6}>
                <CustomButton href="/pdf/ad/2024baitaiguide.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  2024年媒体資料
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

      </div>
    </div>
  );
}

export default Advertisement;
